var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 7.55a1.35 1.35 0 1 1-2.7 0v-5.4a1.35 1.35 0 1 1 2.7 0zM10.6 7.7V2.812a1.8 1.8 0 0 0-.995-1.61L9.56 1.18A3.6 3.6 0 0 0 7.95.8H3.076A1.8 1.8 0 0 0 1.31 2.247l-1.08 5.4A1.8 1.8 0 0 0 1.996 9.8H5.2v3.6A1.8 1.8 0 0 0 7 15.2a.9.9 0 0 0 .9-.9v-.6a3.6 3.6 0 0 1 .72-2.16l1.26-1.68a3.6 3.6 0 0 0 .72-2.16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.0d92aff242a039f13c3a8749c3310612.svg";
export { ForwardRef as ReactComponent };